import type { RefObject } from 'react';

import type { RelativeAbsolutePosition } from '../../../types/pointer-events.js';

/**
 * Resets interactions overlay internal state
 */
export const reset = (
  lastMousePositionRef: RefObject<RelativeAbsolutePosition | undefined>,
  panDeltaRef?: RefObject<number | undefined>,
) => {
  if (panDeltaRef) {
    panDeltaRef.current = undefined;
  }

  lastMousePositionRef.current = undefined;
};
